module.exports = __webpack_public_path__ + "img/3.c58e4a6d.png";